import { COLORS } from "./colors"

export const theme = {
  extend: {
    keyframes: {
      "slide-up": {
        "0%": { transform: "translateY(100%)" },
        "100%": { transform: "translateY(0)" },
      },
      "slide-down": {
        "0%": { transform: "translateY(0)" },
        "100%": { transform: "translateY(100%)" },
      },
    },
    animation: {
      "slide-up": "slide-up 0.3s ease-out",
      "slide-down": "slide-down 0.3s ease-out",
    },
    transitionProperty: {
      stroke: "stroke",
    },
    boxShadow: {
      shadow1: "0px 8px 25px 0px rgba(0, 0, 0, 0.20)",
      brandShadow: "10px 35px 40px -25px rgba(208, 171, 255, 0.2)",
      "filter-menu": "0px 20px 20px 0px rgba(0, 0, 0, 0.05)",
      card: "0px 8px 20px 0px rgba(0, 0, 0, 0.07)",
      subtle: "0px 4px 24px 0px rgba(0, 0, 0, 0.10)",
    },
    backgroundImage: {
      "overlay-gradient": "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 100%)",
    },
    fontFamily: {
      haffer: ["var(--font-haffer)"],
      IBMPlexMono: ["var(--font-ibm-plex-mono)"],
      tngrm: ["TNGRM", "sans-serif"],
      camera: ["Camera", "sans-serif"],
      "camera-plain": ["CameraPlain", "sans-serif"],
      "Ivory 2.0": ["Ivory 2.0", "sans-serif"],
    },
    maxWidth: {
      xl: "1400px",
      auto: "auto",
    },
  },
  screens: {
    sm: "640px",
    md: "900px", // Changed from the default 768px
    lg: "1024px",
    xl: "1280px",
  },

  borderRadius: {
    none: "0px",
    sm: "4px",
    md: "8px",
    lg: "12px",
    xl: "16px",
    full: "1000px",
  },
  colors: {
    ...COLORS,
    overlay: "rgba(0, 0, 0, 0.40)",
  },
}
